
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cinemas",
      function () {
        return require("private-next-pages/cinemas.tsx");
      }
    ]);
  